export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/dashboard/Home.vue'),
  },
]
